function Conocenos() {
    return (
        <section id="conocenos">
           <h2>En Yogajom, aprenderás <b className="f-bold">dos ramas</b> de yoga ideales para <br />
            solucionar problemas tanto físicos como emocionales. <br />
            Con ayuda de posturas y meditación, que harán de tí <br />un nuevo ser.</h2>
        </section>
    )
}

export default Conocenos;